import React from 'react';
import styles from './shot-map-goal-view.module.scss';
import classNames from "classnames";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ShotMapGoalViewDetailsCard} from "./shot-map.goal-view.details-card";
import type {ChartEventDetailsModel} from "../../../../domain/full-game/models/chart-events/event/chart-event.details.model";

export const ShotMapGoalViewDetails = (({selectedEvent, controller}: BaseProps) => {
  return (
    <div className={classNames(styles.event_details_container)}>
      {
        selectedEvent?.eventDetails?.map((detail: ChartEventDetailsModel) => <ShotMapGoalViewDetailsCard detail={detail} controller={controller} key={detail.key}/>)
      }
    </div>
  )
});
